<script>
  import axios from 'axios'
  
  export default {
    name: 'FeedbackOverlay',
    data() {
      return {
        isVisible: false,
        feedbackReason: '',
        additionalComments: '',
        queryId: '',
        pathway: '',
        submitted: false,
      }
    },
    methods: {
      showFeedback(queryId, path, type) {
        this.isVisible = true
        this.queryId = queryId
        this.pathway = path
        this.feedbackReason = type
      },
      closeFeedback() {
        this.isVisible = false
        this.feedbackReason = ''
        this.additionalComments = ''
      },
      async submitFeedback() {

        try {
          const response = await axios.post('https://langserve-copilot-dp7nm56cca-as.a.run.app/general/feedback', {
            QueriesUuid: this.queryId,
            Pathway: this.pathway,
            Feedback_Response: (this.feedbackReason === 'good') ? 1 : 0,
            Feedback_Reason: this.feedbackReason,
            Additional_Comments: this.additionalComments
          })
          
          if (response.status === 200) {
            this.submitted = true
            setTimeout(() => {
              this.$emit('feedback-submitted', this.feedbackReason)
              this.closeFeedback()
            }, 2000)          
          }
        } catch (error) {
          console.error('Error submitting feedback:', error)
        }
      }
    }
  }
</script>

<template>
    <div class="feedback-overlay" v-if="isVisible">
      <div class="feedback-modal">
        <div class="feedback-header">
          <h3 class="feedback-title">Share Your Feedback</h3>
          <button class="close-btn" @click="closeFeedback">
            <i class="fas fa-times"></i>
          </button>
        </div>
        
        <div class="feedback-content" v-if="!submitted">

            <div class="feedback-reason">
                <div v-if="feedbackReason === 'good'" class="reason-text positive">
                  <h4>What was good about this response?</h4>
                  <p>Your feedback helps us improve our responses</p>
                </div>
                <div v-else-if="feedbackReason === 'bad'" class="reason-text negative">
                  <h4>What could be improved?</h4>
                  <p>Help us understand what went wrong</p>
                </div>
            </div>
  
          <textarea 
            v-model="additionalComments"
            placeholder="Tell us more about your experience (optional)"
            rows="4"
            class="feedback-textarea"
          ></textarea>
  
          <div class="feedback-actions">
            <button 
              class="submit-btn" 
              @click="submitFeedback"
              :disabled="!feedbackReason"
            >
              Submit
            </button>
          </div>
        </div>

        <div class="feedback-content" v-else>
          <div class="feedback-reason">
            <div class="reason-text positive">
              <h3>Thank you for your feedback!</h3>
              <p>Your feedback helps us improve our responses</p>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
  
<style scoped>
  .feedback-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  
  .feedback-modal {
    background: white;
    border-radius: 12px;
    width: 90%;
    max-width: 500px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  }
  
  .feedback-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    border-bottom: 1px solid #eee;
  }
  
  .feedback-title {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 600;
    color: #2c3e50;
  }
  
  .close-btn {
    background: transparent;
    border: none;
    color: #666;
    font-size: 1.25rem;
    cursor: pointer;
    padding: 8px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
  }
  
  .close-btn:hover {
    background: #f5f5f5;
    color: #333;
  }
  
  .feedback-content {
    padding: 10px
  }
  
  .feedback-buttons {
    display: flex;
    justify-content: center;
    gap: 16px;
    margin-bottom: 24px;
  }
  
  .reaction-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 24px;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    background: white;
    cursor: pointer;
    transition: all 0.2s ease;
    font-weight: 500;
  }
  
  .reaction-btn:hover {
    border-color: #4CAF50;
    background: #f5f5f5;
  }
  
  .reaction-btn.active {
    background: #4CAF50;
    color: white;
    border-color: #4CAF50;
  }
  
  .feedback-textarea {
    width: 100%;
    padding: 16px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    margin-bottom: 24px;
    resize: vertical;
    font-family: inherit;
    font-size: 0.95rem;
    transition: border-color 0.2s ease;
  }
  
  .feedback-textarea:focus {
    outline: none;
    border-color: #4CAF50;
  }
  
  .feedback-actions {
    display: flex;
    justify-content: flex-end;
  }
  
  .submit-btn {
    background: #4CAF50;
    color: white;
    border: none;
    padding: 12px 32px;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 500;
    transition: background 0.2s ease;
  }
  
  .submit-btn:hover:not(:disabled) {
    background: #45a049;
  }
  
  .submit-btn:disabled {
    background: #cccccc;
    cursor: not-allowed;
  }
</style>


<style scoped>
.feedback-reason {
  text-align: center;
  margin: 20px 0;
  padding: 16px;
  border-radius: 8px;
  background: #f8f9fa;
}

.reason-text h4 {
  margin: 0 0 8px 0;
  font-size: 1.1rem;
  font-weight: 600;
}

.reason-text p {
  margin: 0;
  font-size: 0.9rem;
  color: #666;
}

.positive h4 {
  color: #2e7d32;
}

.negative h4 {
  color: #c62828;
}
</style>
  